<template>
  <v-container>
    <v-alert text prominent type="error" icon="mdi-cloud-alert" v-if="alertError!=''">
      {{alertError}}
    </v-alert>
    <v-alert text prominent type="success" icon="mdi-cloud-alert" v-if="alertSuccess!=''">
      {{alertSuccess}}
    </v-alert>
    <template>
      <v-card class="md-auto mb-5">
        <!-- <v-toolbar>
          <v-toolbar-title>School District: {{ user.schoolDistrict }}    >    School: {{ user.school }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title class="mx-5">Total Students Licences: {{ School.StudentLicencesAssigned }}</v-toolbar-title>
          <v-toolbar-title class="mx-5">Licences Available: {{ School.AvailableStudentLicences }}</v-toolbar-title>
          <v-btn color="primary" dark class="mb-2" @click="dialogStudent = true">
            New Student
          </v-btn>
        </v-toolbar> -->
        <v-row>
          <v-col cols="12" md="10" lg="10">
            <v-row>
              <v-col cols="6" md="3" lg="3" class="text-h6 pl-4">
                School District: {{ user.SchoolDistrict }}
              </v-col>
              <v-col cols="6" md="3" lg="3" class="text-h6 pl-5" v-if="IsDistrictAdmin">
                <v-select
                v-model="SchoolSelect"
                outlined
                :items="ShoolsList"
                item-text="name"
                menu-props="auto"
                label="Select Country"
                hide-details
                return-object
                single-line
                @change="SchoolChange"
              ></v-select>
              </v-col>
              <v-col cols="6" md="3" lg="3" class="text-h6 pl-4" v-else>
                School: {{ user.School }}
              </v-col>
              <v-col cols="6" md="3" lg="3" class="text-h6 pl-4">
                Total Students Licences: {{ School.StudentLicencesAssigned }}
              </v-col>
              <v-col cols="6" md="3" lg="3" class="text-h6 pl-4">
                Licences Used: {{ School.AvailableStudentLicences }}
              </v-col>
              <v-col cols="10" md="2" lg="2" class="text-h6 pl-4">
                
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="10" md="2" lg="2">
            <v-btn color="primary" dark class="mb-2" @click="dialogStudent = true" :disabled="!HaveLicences">
              New Student
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <!-- <v-card class="my-5">
        <v-toolbar flat color="cyan lighten-5">
          <v-toolbar-title>
            Students created for clever but not initialized
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <template v-for="(element, index) in PendingStudents">
          <v-chip class="ma-2" color="cyan" label text-color="white" :key="index">
            <v-icon left>
              mdi-account
            </v-icon>
            {{ element.email }}
          </v-chip>
        </template>
      </v-card> -->

      <v-data-table :headers="tableHeader" :items="students" sort-by="name" class="elevation-1" id="downloadexcel" >
        <template v-slot:top>
          <v-row>
            <v-col cols="2">
              <p class="text-h5 text-center"> Students</p>
            </v-col>
            <v-col cols="3">
              <v-select :items="teachersList" v-model="teacherFilterValue" label="Teacher" outlined></v-select>
            </v-col>
            <v-col cols="3">
              <v-select :items="gradosList" v-model="gradoFilterValue" label="Grade" outlined></v-select>
            </v-col>
            <v-col>
              <v-btn color="success" elevation="2" @click="ExportExcel('xls')">Export <v-icon right dark>mdi-file-excel</v-icon></v-btn>
            </v-col>
            <v-col>Total Usage time: {{ TotalStudentsTimeUsage }} </v-col>
          </v-row>
          <v-dialog v-model="dialogStudent" max-width="1000px">
              <v-card>
                <v-form ref="form" v-model="valid"  @submit.prevent="save" lazy-validation>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field v-model="student.name" outlined :rules="nameRules" label="Name" prepend-icon="mdi-account" required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field v-model="student.lastName" outlined :rules="nameRules" label="Last Name" prepend-icon="mdi-account" required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu v-model="dateOfBirth" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="student.dateOfBirth" outlined label="Date of Birth (optional)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                          </template>
                          <v-date-picker v-model="student.dateOfBirth" @input="dateOfBirth = false"></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="student.email" outlined :rules="emailRules" label="Email" prepend-icon="mdi-email"></v-text-field>
                      </v-col>
                      <!-- <v-col class="d-flex" cols="12" sm="6" md="6">
                        <v-select :items="['Clever','Email and Google']" prepend-icon="mdi-apple-keyboard-option" v-model="student.typeLogin" outlined label="Select Type Login"></v-select>
                      </v-col> -->
                      <v-col cols="12" sm="6" md="6" >
                        <v-text-field v-model="student.studentId" outlined label="Password" prepend-icon="mdi-lock" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" @keydown="changeStudentId"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" >
                        <!--<v-text-field v-model="student.password" outlined prepend-icon="mdi-lock" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :rules="(editedUID === -1)?[passwordRules.required, passwordRules.min]:[]" :type="showPassword ? 'text' : 'password'" label="Password" counter @click:append="showPassword = !showPassword" v-if="!useIdPassword"></v-text-field>
                        <p v-else> you are using student code as password, press if you want to use a different password <v-btn class="ma-2" outlined color="indigo" @click="changePassword">Change Password</v-btn></p>-->
                      </v-col>
                       <v-col cols="12" sm="6" md="6" v-if="School.IsDemo">
                        <v-checkbox v-model="IsDemo" :class="IsDemo?'green--text-chk':'red--text-chk'" :label="`Demo user: ${IsDemo?'Active':'Inactive'}`"></v-checkbox>
                        <label class="grey--text mt-n5">Unlock all levels and all games for demonstrations.</label>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" text type="submit">
                    Save
                  </v-btn>
                </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="headline">Are you sure you want to delete?</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="deleteUserConfirm">OK</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editUser(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteUser(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </template>
    <v-dialog v-model="dialogLoad" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Wait Please
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { db, functions, auth } from '../../../plugins/firebase'
import firebase from 'firebase'
export default {
  data () {
    return {
      user: {},
      tableHeader: [
        { text: 'Name', value: 'name' },
        { text: 'Last Name', value: 'lastName' },
        //{ text: 'Email', value: 'email' },
        { text: 'Usage time', value: 'timeUse' },
        { text: 'Grade', value: 'className', filter: this.gradosFilter,},
        { text: 'Teacher', value: 'teacher', filter: this.teachersFilter},
        //{ text: 'Enabled', value: 'enabled' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      students: [],
      student: {
        name: '',
        lastName: '',
        dateOfBirth: '',
        email: '',
        studentId: '',
        password: '',
        typeLogin: ''
      },
      nameRules: [
        v => (v && v.length >= 2) || 'Minimum length is 2 characters',
        v => (v && v.length <= 30) || 'Name must be less than 30 characters'
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 6 || 'Min 6 characters',
        emailMatch: () => (`The email and password you entered don't match`),
      },
      clearStudent: {
        name: '',
        lastName: '',
        dateOfBirth: '',
        email: '',
        studentId: '',
        password: '',
        typeLogin: ''
      },
      editedUID: -1,
      dialogStudent: false,
      dialogDelete: false,
      dialogLoad: false,
      valid: true,
      alertError: '',
      alertSuccess: '',
      showPassword: true,
      useIdPassword: true,
      dateOfBirth: false,
      collection: 'Students',
      PendingStudents: [],
      School: {},
      gradoFilterValue: '',
      gradosList: [
        {text: "All", value: null},
        {text: "Pre-School", value: 'Pre-School'},
        {text: "Kindergarten", value: 'Kindergarten'},
        {text: '1st Grade', value: '1st Grade'},
        {text: '2nd Grade', value: '2nd Grade'},
        {text: '3rd Grade', value: '3rd Grade'},
        {text: '4th Grade', value: '4th Grade'},
        {text: '5th Grade', value: '5th Grade'},
        {text: '6th Grade', value: '6th Grade'},
        {text: '7th Grade', value: '7th Grade'},
        {text: '8th Grade', value: '8th Grade'},
        {text: '9th Grade', value: '9th Grade'},
        {text: '10th Grade', value: '10th Grade'},
        {text: '11th Grade', value: '11th Grade'}
      ],
      teachersList: [
         {text: "All", value: null},
      ],
      teacherFilterValue: '',
      IsDemo: false,
      TotalStudentsTimeUsage: 0,
      HaveLicences: false,
      IsDistrictAdmin: false,
      ShoolsList:[],
      SchoolSelect:""
    }
  },
  created () {
    this.SchoolAdmin();
  },
  methods: {
    // ListStudents () {
    //   this.getStudents().then(response => {
    //     this.students = response;
    //   });
    // },
    editUser (data) {
      this.editedUID = data.id;
      // this.student = Object.assign({}, data)
      this.GetDataUser().then((getUser) => {
        console.log(getUser);
        this.student.name = getUser.Name;
        this.student.lastName = getUser.LastName;
        this.student.dateOfBirth = getUser.DateOfBirth;
        this.student.email = getUser.Email;
        this.student.studentId = getUser.StudentId;
        this.IsDemo = getUser.IsDemo;
        if (this.IsDemo == undefined) {
          this.IsDemo = false;
        }
        this.useIdPassword = false;
      });
      this.dialogStudent = true;
    },
    deleteUser (data) {
      this.editedUID = data.id;
      this.student = Object.assign({}, data)
      this.dialogDelete = true
    },
    deleteUserConfirm () {
      let respuesta = this.deleteData(this.editedUID);
      console.log(respuesta);
      this.closeDelete()
      //location.reload();
    },
    close () {
      this.dialogStudent = false
      this.$refs.form.resetValidation()
      this.$nextTick(() => {
        this.student = Object.assign({}, this.clearStudent)
        this.editedUID = -1
      })
    },
    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.student = Object.assign({}, this.clearStudent)
        this.editedUID = -1
      })
    },
    save () {
      if (!this.$refs.form.validate()) return;
      if (this.editedUID !== -1) {
        this.dialogLoad = true;
        this.updateData(this.student).then(response => {
          console.log(response);
          if (response.result) {
            this.alertSuccess = "update successfully ";
            let principal = this;
            this.SchoolChange();
            this.GetPendingUsers();
            setTimeout(function () { principal.alertSuccess = '' }, 3000);
          } else {
            let principal = this;
            if (Object.prototype.hasOwnProperty.call(response.message, 'code')) {
              switch (response.message.code) {
                case 'not-found':
                  this.alertError = 'user not found';
                  break;
                default:
                  this.alertError = response.message.code;
              }
            } else {
              this.alertError = response.message;
            }
            setTimeout(function () { principal.alertError = '' }, 3000);
          }
          this.dialogLoad = false
        });
      } else {
        this.dialogLoad = true;
        this.createData(this.student).then(response => {
          console.log(response);
          if (!response.result) {
            this.alertError = response.message;
            let principal = this;
            setTimeout(function () { principal.alertError = '' }, 3000);
          } else {
            this.alertSuccess = "created successfully ";
            let principal = this;
            this.SchoolChange();
            this.GetPendingUsers();
            setTimeout(function () { principal.alertSuccess = '' }, 3000);
          }
          this.dialogLoad = false
        });
      }
      this.close()
      this.$refs.form.resetValidation()
    },
    validate () {
      this.$refs.form.validate()
    },
    // llamadas a firebase
    async createData (student) {
      let answer = { result: '', message: '' }
      try {
        // if (student.typeLogin == 'Clever') { // se quito la opcion  a clever porque se crea automaticamente
        //   console.log(student)
        //   let email = student.email;
        //   let existe = await this.existsUser(email);
        //   console.log(existe)
        //   if (existe) {
        //     answer.result = false;
        //     answer.message = 'this email already exists';
        //     return answer;
        //   }
        //   console.log('antes de batch');
        //   let emailSplit = email.replace(".", "_--_");
        //   //console.log(emailSplit)
        //   var batch = db.batch();
        //   batch.update(db.doc(this.user.reference.path),{ [`PendingStudents.${[emailSplit]}`]: { email:email, name:student.name, lastName:student.lastName }});
        //   batch.set(db.collection("PreUsersClever").doc(email), { school: this.user.school, schoolDistrict: this.user.schoolDistrict, licenseExpirationDate: this.user.pickerExpiration });
        //   await batch.commit();
        //   this.GetPendingUsers();
        //   answer.result = true;
        //   return answer;
        // }
        student.collection = this.collection;
        student.schoolDistrict = this.user.SchoolDistrict;
        student.school = this.user.School;
        student.dateExpiration = this.user.PickerExpiration.toDate().getTime();
        student.IsDemo = this.IsDemo;
        student.reference = this.user.Reference.path;
        if (this.useIdPassword) {
          student.password = student.studentId;
        }
        console.log(student)
        const setAdmin = functions.httpsCallable('createStudent')
        await setAdmin(student)
          .then(() => {
            answer.result = true;
          })
      } catch (error) {
        answer.result = false;
        answer.message = error;
        // console.log(error);
      }
      return answer;
    },
    async existsUser (email) {
      let signInMethods = await auth().fetchSignInMethodsForEmail(email);
      if (signInMethods.length == 0) {
        let docVerify = await db.collection("PreUsersClever").doc(email).get();
        if (!docVerify.exists) {
          console.log('No existe!');
          return false;
        } else {
          console.log('si existe');
          return true
        }
              
      } else {
        console.log(signInMethods)
        console.log('si existe')
        return true;
      }
    },
    async updateData (student) {
      let answer = { result: '', message: '' }
      try {
        student.uid = this.editedUID;
        student.collection = this.collection;
        student.schoolDistrict = this.user.SchoolDistrict;
        student.reference = this.user.Reference.path;
        student.school = this.user.School;
        student.IsDemo = this.IsDemo;
        // if (student.password !== '') {
        //   console.log('asd')
        // }
        const updatetAdmin = functions.httpsCallable('updateStudent')
        await updatetAdmin(student)
        answer.result = true;
      } catch (error) {
        answer.result = false;
        answer.message = error;
        console.log('entro al log general');
      }
      return answer;
    },
    async deleteData (id) {
      console.log(id)
      console.log(this.user.Reference.path)

      this.dialogLoad =true;
      //let answer = { resultado: '', mensaje: '' }
      try {
        const deleteStudent = functions.httpsCallable('deleteStudent')
        let res =await deleteStudent({id: id, path: this.user.Reference.path, studentId: this.user.StudentId, classroomPath: this.user.ClassroomPath})
        console.log(res)
        this.dialogLoad =false;
        this.GetStudentsTable();
        this.GetPendingUsers();
      } catch (error) {
        console.log(error)
        this.dialogLoad =false;
      }
      // db.collection('Students').doc(id).delete().then(() => {
      //   answer.resultado = true;
      // }).catch((error) => {
      //   answer.mensaje = error;
      //   answer.resultado = false;
      // })
      //return answer;
    },
    async Users () {
      await db.collection(this.table).onSnapshot((snapshotChange) => {
        this.users = [];
        snapshotChange.forEach((doc) => {
          let oneStudent = doc.data();
          oneStudent.id = doc.id;
          this.users.push(oneStudent);
        });
      }, (error) => {
        console.log(error);
      })
    },
    async GetDataUser () {
      let getData = await db.collection('Students').doc(this.editedUID).get();
      return getData.data();
    },
    async SchoolAdmin () {
      let uidLogin = this.$store.state.user.uid;
      let UserData = await db.collection('SchoolAdmin').doc(uidLogin).get();
      this.user = UserData.data();
      if (Object.prototype.hasOwnProperty.call(UserData.data(), 'IsDistrictAdmin')) {
        if (UserData.data().IsDistrictAdmin === true) {
          this.IsDistrictAdmin = true;
          this.ListSchools();
          return;
        }
      }
      // aca deberiamos verificar si el usuario expiro
      // listamos
      this.GetStudentsTable();
      this.GetPendingUsers();
      
    },
    async GetStudentsTable(){
      // this.dialogLoad = true;
      let AllStudentsData = "";
      if (this.IsDistrictAdmin) {
        AllStudentsData = await db.doc(this.user.DistrictReference.path+'/Schools/'+this.SchoolSelect.id).collection('StudentsData').doc('P1').get();
      }else{
        AllStudentsData = await this.user.Reference.collection('StudentsData').doc('P1').get();
      }
      let studentsData = AllStudentsData.data().Students;
      let newStudents = [];
      let TotalTimeUse = 0;
      if (Object.keys(studentsData).length !== 0) {
        let ids = Object.keys(studentsData);
        this.School.AvailableStudentLicences =ids.length;
        // for (const element of ids) {
        ids.forEach(async element => {
          let timeUse = 0;
          let student = await db.collection('Students').doc(element).get();
          if (Object.prototype.hasOwnProperty.call(student.data(), 'Alumno')) {
            if (student.data().Alumno.AprendizajeM1v2 !=null) {
              timeUse += student.data().Alumno.AprendizajeM1v2.TiempoTotalUso;
            }
            if (student.data().Alumno.AprendizajeM2v2 !=null) {
              timeUse += student.data().Alumno.AprendizajeM2v2.TiempoTotalUso;
            }
            if (student.data().Alumno.AprendizajeM3v2 !=null) {
              timeUse += student.data().Alumno.AprendizajeM3v2.TiempoTotalUso;
            }
            if (student.data().Alumno.AprendizajeM4v2 !=null) {
              timeUse += student.data().Alumno.AprendizajeM4v2.TiempoTotalUso;
            }
            if (student.data().Alumno.AprendizajeM5v2 !=null) {
              timeUse += student.data().Alumno.AprendizajeM5v2.TiempoTotalUso;
            }
            if (student.data().Alumno.AprendizajeM6v2 !=null) {
              timeUse += student.data().Alumno.AprendizajeM6v2.TiempoTotalUso;
            }
            if (student.data().Alumno.AprendizajeM7v2 !=null) {
              timeUse += student.data().Alumno.AprendizajeM7v2.TiempoTotalUso;
            }
          }
          //console.log(studentsData[element].userUIDSTeacher);
          let className = '';
          let teacherName ='';
          if (studentsData[element].UserUIDSTeacher != '') {
            let teacher = await db.collection('SchoolTeacher').doc(studentsData[element].UserUIDSTeacher).get();
            let classroom = teacher.data().Classrooms;
            teacherName = teacher.data().Name + ' ' + teacher.data().LastName;
            let clasesNames = Object.keys(classroom);
            for (const ClassroomSelected of clasesNames) {
             let TempClassData = await db.collection('SchoolTeacher').doc(studentsData[element].UserUIDSTeacher).collection('Classrooms').doc(ClassroomSelected).get();
             if (Object.prototype.hasOwnProperty.call(TempClassData.data().MainGroup, element)) {
                className = TempClassData.data().Grade;
              }
            }
            //console.log(teacher.data())
          }
          if (teacherName != '') {
            this.teachersList.push({ text: teacherName, value: teacherName });
          }
          TotalTimeUse += timeUse;
          newStudents.push({ id: element, name: studentsData[element].Name, lastName: studentsData[element].LastName, email: studentsData[element].Email , timeUse : this.secondsToString(Math.round( timeUse )), className :className, teacher: teacherName})
          this.TotalStudentsTimeUsage = this.secondsToString(Math.round( TotalTimeUse ))
        });
      }
      this.students = newStudents; 
      // this.dialogLoad = false;
    },
    async GetPendingUsers (){
      console.log("acceso")
      this.PendingStudents = [];
      let doc;
      if (this.IsDistrictAdmin) {
        doc = await db.doc(this.user.DistrictReference.path+'/Schools/'+this.SchoolSelect.id).get();
      }else{
        doc = await db.doc(this.user.Reference.path).get();
      }
      // let doc = await db.doc(this.user.Reference.path).get();
      console.log(doc.data());
      this.School.StudentLicencesAssigned = doc.data().StudentLicencesAssigned;
      this.School. IsDemo = doc.data().IsDemo;
      if (doc.data().ExactLicences == true) {
        if (doc.data().AvailableStudentLicences > 0) {
          this.HaveLicences = true;
        }else{
          this.HaveLicences = false;
        }
      }else{
        this.HaveLicences = true;
      }
    },
    changeStudentId () {
      // console.log(this.student.studentId)
      if (this.useIdPassword) {
        this.student.password = this.student.studentId;
      }
    },
    changePassword () {
      this.useIdPassword = !this.useIdPassword;
    },
    secondsToString (seconds) {
      var hour = Math.floor(seconds / 3600);
      hour = (hour < 10)? '0' + hour : hour;
      var minute = Math.floor((seconds / 60) % 60);
      minute = (minute < 10)? '0' + minute : minute;
      var second = seconds % 60;
      second = (second < 10)? '0' + second : second;
      if (hour == '00') {
        return minute + ' m ' + second + ' s';
      }
      return hour + ' h ' + minute + ' m ' + second + ' s';
    },
    ExportExcel(){
      let dia = new Date();
      let table2excel = new Table2Excel();
      table2excel.export(document.getElementsByTagName("table"),"LeeLee Student Edition "+dia.toLocaleDateString());
    },
    gradosFilter(value) {

        // If this filter has no value we just skip the entire filter.
        if (!this.gradoFilterValue) {
          return true;
        }

        // Check if the current loop value (The calories value)
        // equals to the selected value at the <v-select>.
        return value === this.gradoFilterValue;
      },
    teachersFilter(value){
        if (!this.teacherFilterValue) {
          return true;
        }

        // Check if the current loop value (The calories value)
        // equals to the selected value at the <v-select>.
        return value === this.teacherFilterValue;
    },
    SchoolChange(){
      this.GetStudentsTable();
      this.GetPendingUsers();
    },
    async ListSchools(){
      let escuelas = await this.user.DistrictReference.get();
      let idsTime = Object.keys(escuelas.data().Schools);
      let listaEscuelas = [];
      idsTime.forEach(element => {
        listaEscuelas.push({id: element, name:escuelas.data().Schools[element] })
      });
      this.ShoolsList = listaEscuelas;
    }
  },
  computed: {
    formTitle () {
      return this.editedUID === -1 ? 'New Student' : 'Edit Student'
    },
  },
  watch: {
    dialogStudent (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
    dialogLoad (val) {
      // if (!val) return
      // console.log(this.$nuxt.isOffline);
      // setTimeout(() => (this.dialogLoad = false), 4000)
    },
  }
}
</script>
<style>
  .green--text-chk .v-label {
    color: green !important;
  }

  .red--text-chk .v-label {
    color: red !important;
  }
</style>
